export default __webpack_public_path__ + "static/media/7.fc07f84e.png";